import { createReducer, on } from '@ngrx/store';
import * as AuthActions from './auth.actions';
import { initialAuthState } from './auth.state';

export const authReducer = createReducer(
  initialAuthState,
  on(
    AuthActions.loginSuccess,
    (
      state,
      {
        token,
        id,
        expiresAt,
        refreshToken,
        email,
        firstName,
        surName,
        dateFormat,
        timeFormat,
        language,
        timeZone,
        roles,
        claims,
        permissionGroups,
        companyId,
        tenantId,
        isTemporary,
        bankRelationshipId,
        bankRelationshipName,
        temporaryAccessExpiration,
      }
    ) => ({
      ...state,
      token,
      id,
      expiresAt,
      refreshToken,
      email,
      firstName,
      surName,
      dateFormat,
      timeFormat,
      language,
      timeZone,
      roles,
      claims,
      permissionGroups,
      companyId,
      tenantId,
      isTemporary,
      bankRelationshipId,
      bankRelationshipName,
      temporaryAccessExpiration,
    })
  ),
  on(AuthActions.logout, () => initialAuthState),
  on(AuthActions.updateClaims, (state, { claims }) => ({
    ...state,
    claims,
  })),
  on(AuthActions.setLanguage, (state, { language }) => ({
    ...state,
    language,
  })),
  on(AuthActions.setLoadingMessage, (state, { loadingMessage }) => ({
    ...state,
    loadingMessage,
  })),
  on(AuthActions.setCompanyId, (state, { companyId }) => ({
    ...state,
    companyId,
  })),
  on(AuthActions.clearCompanyId, state => ({
    ...state,
    companyId: null,
  })),
  on(AuthActions.setUserLoggedCustomCompanies, (state, { companyIds }) => ({
    ...state,
    userLoggedCustomCompanies: companyIds,
  })),
  on(AuthActions.clearUserLoggedCustomCompanies, state => ({
    ...state,
    userLoggedCustomCompanies: [],
  })),
  on(AuthActions.setSelectedEconomicGroup, (state, { id, name }) => ({
    ...state,
    selectedEconomicGroupId: id,
    selectedEconomicGroupName: name,
  })),
  on(AuthActions.clearSelectedEconomicGroup, state => ({
    ...state,
    selectedEconomicGroupId: null,
    selectedEconomicGroupName: null,
  }))
);
